import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';

export interface IThemePreviewProps extends IBaseElementProps {}

const ThemePreview: React.FC<IThemePreviewProps> = ({
	className,
	classNames = [],
}) => {
	return (
		<div className={className || cn('calian-theme-preview', ...classNames)}>
			<div className="container-fluid mw-1440px">
				<div className="row">
					<div className="col-12 mx-auto py-5">
						<h1 className="text-center">Theme Previews</h1>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ThemePreview;
